import { render, staticRenderFns } from "./CompleteRequest.vue?vue&type=template&id=0b3c89b6&scoped=true"
import script from "./CompleteRequest.vue?vue&type=script&lang=js"
export * from "./CompleteRequest.vue?vue&type=script&lang=js"
import style0 from "./CompleteRequest.vue?vue&type=style&index=0&id=0b3c89b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3c89b6",
  null
  
)

export default component.exports